import { render, staticRenderFns } from "./LatestEvaluation.vue?vue&type=template&id=0a56196a&"
import script from "./LatestEvaluation.vue?vue&type=script&lang=js&"
export * from "./LatestEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./LatestEvaluation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-suitability/src/components/main/LatestEvaluation.vue"
export default component.exports